import DeleteIcon from '@usas/ui-web/components/icons/DeleteIcon';

import global from '@usas/ui-web/components/GlobalStyle.module.css';
import style from '../../Entry.module.css';

import { formatDate } from '@usas/ui-web/utils/DateFunctions';

const GridRow = ({ credential, onDeleteCredentialClicked }) => {
  return (
    <tr key={credential.orgUnitNonAthleteEntryId}>
      <td>{(credential.firstName || credential.middleName || credential.lastName) ? `${credential.firstName || ''} ${credential.preferredName !== '' && credential.preferredName !== credential.firstName ? '"' + credential.preferredName + '"' : ''} ${credential.middleName || ''} ${credential.lastName || ''}` : ''}</td>
      <td>{credential.memberId || ''}</td>
      <td className={style.Email}>{credential.email || ''}</td>
      <td>{credential.isInGoodStanding === true ? 'Yes' : credential.isInGoodStanding === false ? 'No' : ''}{credential.isInGoodStandingExpirationDate ? ` (${formatDate(credential.isInGoodStandingExpirationDate)})` : ''}</td>
      <td>{credential.typeName || ''}</td>
      <td>
        {onDeleteCredentialClicked && credential.hasPaid === false &&
          <button className={global.IconButtonMargin}
            type="button"
            onClick={(e) => onDeleteCredentialClicked(e, credential)}>
            <DeleteIcon />
          </button>}
      </td>
    </tr>
  );
};

const OrgUnitAdminCredentialsLargeGrid = ({ gridData, isLoading, onDeleteCredentialClicked }) => (
  <table className={[global.UsasTable, 'visible-md visible-lg'].join(' ')}>
    <thead>
      <tr>
        <th style={{ minWidth: '150px' }}>Name</th>
        <th style={{ minWidth: '130px' }}>Member Id</th>
        <th>Email</th>
        <th style={{ width: '160px' }}>Is In Good Standing? (Expiration Date)</th>
        <th>Credential</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      {isLoading === true ?
        <tr><td colSpan="6">Loading...</td></tr>
        : Array.isArray(gridData) && gridData.length > 0 ?
          gridData.map((credential, i) =>
            <GridRow
              key={i}
              credential={credential}
              onDeleteCredentialClicked={onDeleteCredentialClicked} />)
          :
          <tr>
            <td colSpan={6}>No Credentials</td>
          </tr>
      }
    </tbody>
  </table>
);

export default OrgUnitAdminCredentialsLargeGrid;